// AUTO-GENERATED FILE - DO NOT EDIT
import * as z from "zod";
import { requestHandler } from "../requestHandler";

export const path = "get-carrier-load-history";

export const getCarrierLoadHistoryParamsSchema = z.object({
    carrierId: z.string(),
});

export const loadSchema = z.object({
    driverName: z.string().nullable(),
    loadName: z.string().nullable(),
    loadId: z.string(),
    pickupLocation: z.string(),
    deliveryLocation: z.string(),
    pickupDate: z.string().nullable(),
    deliveryDate: z.string().nullable(),
    weight: z.number(),
    status: z.string(),
});

export const getCarrierLoadHistoryResponseSchema = z.array(loadSchema);




export type GetCarrierLoadHistoryParams = z.infer<
    typeof getCarrierLoadHistoryParamsSchema
>;

export type Load = z.infer<typeof loadSchema>;

export type GetCarrierLoadHistoryResponse = z.infer<
    typeof getCarrierLoadHistoryResponseSchema
>;




// broker/get-carrier-load-history endpoint
export function getCarrierLoadHistory(
  params: z.input<typeof getCarrierLoadHistoryParamsSchema>
): Promise<GetCarrierLoadHistoryResponse> {
  return requestHandler(
    "broker/get-carrier-load-history",
    params,
    getCarrierLoadHistoryResponseSchema,
  );
}

